import {Button, Link, Menu, MenuItem} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {CSVLink} from "react-csv";
import React, {useContext, useMemo, useState} from 'react';
import CampaignToolbarTypeSwitch from "./CampaignToolbarTypeSwitch";
import {useNavigate} from "react-router";
import {useSearchParams} from "react-router-dom";

export default function CampaignToolbar({
                                            showAllGroups, setShowAllGroups,
                                            showRainbow, setShowRainbow,
                                            sortByType, setSortByType,
                                            setConfigCheck,
                                            initialViewType,
                                            setCalendarMode,
                                            generateCSVData,
                                            env,
                                            activateCampaigns,
                                            upgradeCampaigns,
                                            selectedList,
                                            bulkUpdate,
                                            handleSelectAll,
                                            allVisibleItems

                                        }) {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);


    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };


    const getExpandTitle = () => {
        if (showAllGroups == true) return "expand all"
        return "collapse all"
    }
    const getRainbowTitle = () => {
        if (showRainbow == false) return "priority order"
        return "start order"
    }


    const visibleIds = allVisibleItems ? allVisibleItems.map(i => i.item.id) : [];
    const selectedVisibleCount = visibleIds.filter(id => selectedList?.includes(id)).length;
    const isAllVisibleSelected = visibleIds.length > 0 && selectedVisibleCount === visibleIds.length;

    const getSelectAllTitle = () => {
        if (isAllVisibleSelected) return "deselect all";
        return "select all";
    }

    const handleViewTimeline = () => {
        setCalendarMode({
            active: true,
            env: env
        })
    };
    const handleSortByRecent = () => {
        setSortByType(false);
    };

    const handleSortByType = () => {
        setSortByType(true);
    };

    const [searchParams, setSearchParams] = useSearchParams();
    const [mode, setMode] = useState(searchParams.get('viewType') || initialViewType || 'type')
    const navigate = useNavigate();

    const onSwitchMode = (type) => {
        setMode(type)
        switch (type) {
            case 'type':
                setSortByType(true);
                setConfigCheck(false);
                break;
            case 'recent':
                setSortByType(false);
                setConfigCheck(false);
                break;
            case 'configCheck':
                setSortByType(true);
                setConfigCheck(true);
                break;
            case 'timeline':
                return navigate("/timeline?timelineEnv=" + env);
                break
        }

        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('viewType', type);
        setSearchParams(newSearchParams);
    }


    const canUpdateAudience = useMemo(() => {
        return Array.isArray(selectedList) && selectedList.length > 0;
    }, [selectedList]);



    return <div className="collapse-controls" style={{display: 'flex', alignItems: 'center', paddingTop: '5px'}}>
        <div className="collapse-all-link" onClick={() => {
            if (handleSelectAll) {
                handleSelectAll(!isAllVisibleSelected);
            }
        }}>
            <div>{getSelectAllTitle()}</div>
        </div>
        &nbsp;
        <div className="collapse-all-link" onClick={() => {
            setShowAllGroups(!showAllGroups);
        }}>
            <div>{getExpandTitle()}</div>
        </div>
        &nbsp;
        <div className="collapse-all-link" onClick={() => {
            setShowRainbow(!showRainbow);
            window.localStorage.setItem("show_rainbow_" + env, !showRainbow)
        }}>
            <div>{getRainbowTitle()}</div>
        </div>
        &nbsp;
        <CampaignToolbarTypeSwitch
            onSwitchMode={onSwitchMode}
            mode={mode}
            env={env}
        />

        <div style={{marginLeft: 'auto'}}>
            <IconButton onClick={handleMenuClick}>
                <MoreVertIcon/>
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                <MenuItem onClick={handleMenuClose}>
                    <CSVLink separator={";"} data={generateCSVData()} filename={"campaigns.csv"}>Export to CSV</CSVLink>
                </MenuItem>
                {env !== 'liveops' && env !== 'prod' && selectedList !== undefined &&
                    <MenuItem disabled={selectedList.length==0} onClick={handleMenuClose}>
                        <Link onClick={() => {
                            activateCampaigns(env)
                        }}>Adjust Time</Link>
                    </MenuItem>
                }
                {env !== 'liveops' && env !== 'prod' && selectedList !== undefined &&
                    <MenuItem disabled={selectedList.length==0} onClick={handleMenuClose}>
                        <Link onClick={() => {
                            upgradeCampaigns(env)
                        }}>Upgrade Bundles</Link>
                    </MenuItem>
                }

                {selectedList !== undefined && env !== 'prod' && <MenuItem disabled={selectedList.length==0} onClick={handleMenuClose}>
                    <Link onClick={() => {
                        bulkUpdate(env)
                    }}>Bulk Update audience</Link>
                </MenuItem>}

            </Menu>
        </div>


    </div>
}
